<template>
  <div>
    <component :is="componentToLoad"></component>
  </div>
</template>

<script>
import LaboralDashboardV2 from './LaboralDashboardV2.vue';
import LaboralDashboardV1 from '@/modules/dashboard/views/LaboralDashboardV1.vue';
export default {
  components: {
    LaboralDashboardV2,
    LaboralDashboardV1,
  },

  computed: {
    componentToLoad() {
      return this.hasLaboralModule ? 'laboral-dashboard-v2' : 'laboral-dashboard-v1';
    },
    currentCompany() {
      return this.$store.getters['currentCompany'];
    },
    customerModules() {
      if (!this.currentCompany) {
        return null;
      }
      return this.currentCompany.customer_modules || null;
    },
    hasLaboralModule() {
      if (!this.customerModules) {
        return true;
      }
      return this.customerModules && this.customerModules.laboral;
    },
  },
};
</script>
